export default __webpack_public_path__ + "static/media/Ballroll_00382.9244f7ff.png";